import React, { useEffect } from "react";
import "./Ece_passed_out_students.css";
import {
  Backtotop,
  Floatinmenu,
  Underline,
  ContentCard,
} from "../../widgets";
import {
  ece_dept_menu,
  ece_passed_out_students,
} from "../../constants/ece_dept";

import { RadialMenu } from "../../components";

import { FaMicrochip } from "react-icons/fa6";

const Ece_passed_out_students = () => {
  useEffect(() => {
    document.title = "ACCET-ECE | Ece_passed_out_students";
  }, []);
  return (
    <div className="ecedept">
      <div className="ecebg">
        <div className="eceheading">
          Department of Electronics and Communication Engineering
        </div>
        <div className="ece_sub_heading">Passed Out Students</div>
      </div>
      <section className="ecedark">
        <div className="dept_float_menu">
          <Floatinmenu logo={FaMicrochip} head="Menu" links={ece_dept_menu} />
        </div>
        <RadialMenu menu_links={ece_dept_menu} />
    
        <Underline heading="Passed Out Students" />
        <div className="ece_passed_out_students_card_outer">
          
            {ece_passed_out_students.map((item) => (
              <ContentCard
                key={item.id}
                heading={item.program}
                pdf={item.pdf}
              />
            ))}
        </div>

      </section>

      <Backtotop />
    </div>
  );
};

export default Ece_passed_out_students;
